import React, { type FC, useEffect } from 'react'
import { ToastContainer } from 'react-toastify'

export const NotificationsProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    const styleSheet = `
      :root { --toastify-color-progress-light: white }
      
      /* Target the toast container more specifically */
      .Toastify__toast-container.Toastify__toast-container--bottom-center {
        bottom: 10rem !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
        width: auto !important;
        max-width: 480px !important;
        position: fixed !important;
      }
      
      /* Ensure stacked containers are properly positioned */
      .Toastify__toast-container.Toastify__toast-container--bottom-center[data-stacked="true"] {
        bottom: 10rem !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
        position: fixed !important;
      }
      
      /* Additional specificity for any nested positioning */
      body .Toastify__toast-container.Toastify__toast-container--bottom-center {
        bottom: 10rem !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
        position: fixed !important;
      }
      
      /* Override any inline styles that might be applied */
      .Toastify__toast-container.Toastify__toast-container--bottom-center[style] {
        bottom: 10rem !important;
        left: 50% !important;
        transform: translateX(-50%) !important;
      }
    `
    const styleElement = document.createElement('style')

    styleElement.innerHTML = styleSheet

    document.head.append(styleElement)

    return () => {
      styleElement.remove()
    }
  }, [])

  return (
    <>
      {children}
      <ToastContainer stacked />
    </>
  )
}
